import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { formatWhen, roleLabel } from './activityTimeline';

/**
 * The newest comment on a contract, for a contract list row: two lines of the
 * text, then who wrote it and when. The full text is on hover. The list
 * endpoint sends `latestComment` only to staff, so a supplier never reaches
 * this with one.
 */
const LatestComment = ({ comment }) => {
  if (!comment) {
    return <Typography sx={{ fontSize: '13px', color: '#9ca3af' }}>-</Typography>;
  }
  const role = roleLabel(comment.authorRole);
  return (
    <Tooltip
      title={<Box component="span" sx={{ whiteSpace: 'pre-wrap' }}>{comment.body}</Box>}
      placement="top-start"
    >
      <Box sx={{ maxWidth: 280 }}>
        <Typography
          sx={{
            fontSize: '13px',
            color: '#111827',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            wordBreak: 'break-word',
          }}
        >
          {comment.body}
        </Typography>
        <Typography sx={{ fontSize: '12px', color: '#6b7280', mt: 0.25 }}>
          {comment.authorName}{role ? ` (${role})` : ''} · {formatWhen(comment.createdAt)}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default LatestComment;
